import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import UserProfilePage from '../layouts/UserProfilePage';
import LegalProfessionalProfilePage from '../layouts/LegalProfessionalProfilePage';

const ProfileRouter = () => {
  const { user } = useAuth();

  // Check if user is a legal professional
  if (user?.role_name === 'legal_professional') {
    return <LegalProfessionalProfilePage />;
  }

  // Default to regular user profile
  return <UserProfilePage />;
};

export default ProfileRouter; 